export default __webpack_public_path__ + "videos/particle-glow-trail-silver-360w.0daf5a91fc247eddbbde0e3f03a899f2.mp4";